import React from 'react';
import { Container, Card, Row, Col, Button } from 'react-bootstrap';
import { FiMail, FiTool, FiGlobe } from 'react-icons/fi';

const CONTACTS = [
  {
    title: 'Computer Maintenance',
    lead: 'Stuart Jeffrey',
    email: 'stuart@businessworks.com.au',
    description: 'Hardware, staff devices, on-site network and classroom technology.',
    Icon: FiTool,
  },
  {
    title: 'Website Maintenance',
    lead: 'Shane Kennedy',
    email: 'shanek@emergencedigital.com.au',
    description: 'Website uptime, publishing support, and Avenue School web app enhancements.',
    Icon: FiGlobe,
  },
];

const ContactIT = () => (
  <Container className="py-5">
    <Row className="justify-content-center mb-4">
      <Col md={8}>
        <h2 className="fw-bold text-center mb-3">IT Support Contacts</h2>
        <p className="text-muted text-center">
          Reach out directly to the specialist who can help with your request.
        </p>
      </Col>
    </Row>

    <Row className="g-4 justify-content-center">
      {CONTACTS.map(({ title, lead, email, description, Icon }) => (
        <Col key={title} md={6} lg={5}>
          <Card className="shadow-sm border-0 h-100">
            <Card.Body className="p-4 d-flex flex-column gap-3">
              <div className="d-flex align-items-center gap-3">
                <div className="rounded-circle bg-primary-subtle text-primary d-flex align-items-center justify-content-center" style={{ width: 58, height: 58 }}>
                  <Icon size={26} />
                </div>
                <div>
                  <h4 className="mb-1">{title}</h4>
                  <div className="text-muted">{lead}</div>
                </div>
              </div>
              <p className="text-muted mb-0" style={{ flex: 1 }}>{description}</p>
              <Button
                variant="primary"
                className="d-flex align-items-center justify-content-center gap-2"
                href={`mailto:${email}`}
              >
                <FiMail /> Email {lead.split(' ')[0]}
              </Button>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  </Container>
);

export default ContactIT;
